// extracted by mini-css-extract-plugin
export var backgroundClassName = "CtaSection-module--backgroundClassName--5baaf";
export var contentCotainer = "CtaSection-module--contentCotainer--c6f14";
export var ctaSectionContainer = "CtaSection-module--ctaSectionContainer--f8658";
export var fontColor = "CtaSection-module--fontColor--97c5c";
export var headingStyling = "CtaSection-module--headingStyling--79f96";
export var titleContent = "CtaSection-module--titleContent--189a7";